module.exports = __webpack_public_path__ + "img/no_data.c9c80b4b.png";